import { EmailSettingsTypeType } from '../graphql-types';

export class EmailSettingsTypeEntity {
    constructor(
        public Id: number = null,
        public Description: string = null,
        public PartnerId = null,
    ) {
    }

    public Clone(override: Partial<EmailSettingsTypeEntity> = {}): EmailSettingsTypeEntity {
        const attr = {...this, ...override};
        return Object.assign(new EmailSettingsTypeEntity(), attr);
    }
}

export function EmailSettingsTypeEntityFromBackend(res: EmailSettingsTypeType): EmailSettingsTypeEntity {
    return new EmailSettingsTypeEntity(
        res.id,
        res.description,
        res.partnerId,
    );
}
